import { render, staticRenderFns } from "./lookCOeder.vue?vue&type=template&id=0b2602ec&scoped=true"
import script from "./lookCOeder.vue?vue&type=script&lang=ts"
export * from "./lookCOeder.vue?vue&type=script&lang=ts"
import style0 from "./lookCOeder.vue?vue&type=style&index=0&id=0b2602ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2602ec",
  null
  
)

export default component.exports